import { render, staticRenderFns } from "./release-list.vue?vue&type=template&id=8e2b31b8"
import script from "./release-list.vue?vue&type=script&lang=js"
export * from "./release-list.vue?vue&type=script&lang=js"
import style0 from "./release-list.vue?vue&type=style&index=0&id=8e2b31b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports